<div class="search-table-wrapper">
  <ejs-grid
    [dataSource]="tableData()"
    [allowPaging]="true"
    [allowFiltering]="true"
    [filterSettings]="filterSettings"
    [pageSettings]="{}"
    [rowHeight]="60"
    [height]="'calc(100vh - 250px)'"
    width="100%"
  >
    <e-columns>
      <e-column
        field="name"
        headerText="Patient Name"
        [allowFiltering]="true"
        [isFrozen]="true"
        width="220"
      ></e-column>
      <e-column
        field="mrn"
        headerText="MRN"
        [allowFiltering]="true"
        width="200"
      ></e-column>
      <e-column
        field="patientStatus"
        headerText="Status"
        [allowFiltering]="false"
        [showColumnMenu]="false"
        width="180"
      >
        <ng-template #template let-data>
          <lib-admit-status-badge
            [identifierCode]="data.patientStatus.code"
            [label]="data.patientStatus.label"
          ></lib-admit-status-badge>
        </ng-template>
      </e-column>
      <e-column
        field="physician"
        headerText="Physician"
        [allowFiltering]="true"
        width="260"
      >
        <ng-template #template let-data>
          <div class="location-info">
            <div class="ward-name">{{ data?.physician?.name }}</div>
            <div class="room-code">{{ data?.physician?.specialization }}</div>
          </div>
        </ng-template>
      </e-column>
      <e-column
        field="location"
        headerText="Location"
        [allowFiltering]="false"
        width="260"
      >
        <ng-template #template let-location>
          <div class="location-info">
            <div class="ward-name">{{ location?.location?.wardName }}</div>
            <div class="room-code">{{ location?.location?.roomCode }}</div>
          </div>
        </ng-template>
      </e-column>
      <e-column
        field="module"
        headerText="Module"
        [allowFiltering]="false"
        width="100"
      ></e-column>

      <!-- <e-column
        field="patient.age"
        headerText="Age"
        [allowFiltering]="true"
        width="120"
      ></e-column>
      <e-column
        field="admission.admitStatus.name"
        headerText="Admit Status"
        [allowFiltering]="true"
        width="200"
      >
        <ng-template #template let-data>
          <lib-admit-status-badge
            [statusName]="
              data?.admission?.admitStatus?.name ||
              data?.admission?.admitStatus?.nameEn
            "
            [identifierCode]="data?.admission?.admitStatus?.identifierCode"
          ></lib-admit-status-badge>
        </ng-template>
      </e-column>
      <e-column
        field="admission.admittedOn"
        headerText="Admitted On"
        [allowFiltering]="true"
        width="200"
      >
        <ng-template #template let-data>
          <span class="admitted-date">
            {{
              data.admission?.admittedOn
                ? (data.admission.admittedOn | date: "yyyy-MM-dd")
                : ""
            }}
            <span class="admitted-time" *ngIf="data.admission?.admittedOn">
              {{ data.admission.admittedOn | date: "HH:mm" }}
            </span>
          </span>
        </ng-template>
        <ng-template #filterTemplate>
          <div class="date-range-filter">
            <ejs-daterangepicker
              [startDate]="dateRange()[0]"
              [endDate]="dateRange()[1]"
              (change)="dateRange.set([$event.startDate, $event.endDate])"
              placeholder="Select date range"
            ></ejs-daterangepicker>
          </div>
        </ng-template>
      </e-column>
      <e-column
        field="admission.admittingDoctor.fullName"
        headerText="Admitted By"
        [allowFiltering]="true"
        width="220"
      ></e-column> -->
    </e-columns>
  </ejs-grid>
</div>
